import ConversationEffect from "src/Animations/ConversationEffect";
import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_AI3S_DEMO_5 = {
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "topaz.png",
  title: `<span style="color: #BEE3FF;">These generative AI guardrails also help \nhim safeguard his organizations \ngenerative AI </span>investments from different \nrisks like PII leakage, IP infringement, \nconfidential information leaks, malicious \nuses and also checks hallucinations and \nimproves reliability and explainability`,
  subtitle: "Infosys AI3S DEMO",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage(311),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(309),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "RESPONSIBLE_AI/AI3S_d1_06.png",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "RESPONSIBLE_AI/AI3S_demo_5_computer.png",
          imageStyle: {
            position: "absolute",
            right: "65px",
            bottom: "68px",
          },
          effect: "animate-opacity",
        },
        {
          image: "RESPONSIBLE_AI/AI3S_demo_5_stats.png",
          imageStyle: {
            position: "absolute",
            right: "-20px",
            bottom: "516px",
          },
        },
        {
          image: "RESPONSIBLE_AI/AI3S_demo_5_magnifying_glass.png",
          imageStyle: {
            position: "absolute",
            right: "556px",
            bottom: "140px",
          },
          effect: "animate-opacity",
        },
      ]}
      pageNumber={310}
    />
  ),
};
